export const cv_type = 'cv_background';
